import { DialogContent, DialogTitle, Stack, Typography } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { OkCancel } from "lib/@components/okCancel"
import { useRefresh } from "lib/@hooks/useRefresh"
import UploadDocumentFile from "minimals-template/components/upload/upload-document-file"
import { useState } from "react"
import { DocumentUploadDialogTitle } from "./document-upload-dialog-title"

export function DocumentUploadDialog({
    title,
    subtitle = "Upload File",
    fileSelectText,
    acceptedFileFormat,
    multiple,
    cancel,
}) {
    const [data] = useState({ files: [] })
    const refresh = useRefresh()

    return (
        <Bound target={data} refresh={refresh}>
            <DialogTitle sx={{ pb: 3 }}>
                <DocumentUploadDialogTitle title={title} onClose={cancel} />
            </DialogTitle>
            <DialogContent sx={{ pb: 0 }}>
                <Stack spacing={1}>
                    <Typography variant="subtitle2" color="text.secondary">
                        {subtitle}
                    </Typography>
                    <UploadDocumentFile
                        accept={acceptedFileFormat}
                        fileSelectText={fileSelectText}
                        multiple={multiple}
                    />
                </Stack>
            </DialogContent>
            <OkCancel value={{ files: data?.files }} okDisabled={data?.files?.length === 0} />
        </Bound>
    )
}
